// @flow

import _ from 'lodash';

export const getRouteParam = (props: Object, paramName: string) => _.get(props.match, `params.${paramName}`);

export const getIdRouteParamFromProps = (props: Object) => getRouteParam(props, 'id');

export const getRouteState = (props: Object, stateName: string) => _.get(props.location.state, stateName);

export const getSearchParam = (props: Object, paramName: string) => {
  const params = new URLSearchParams(props.location.search);
  return params.get(paramName);
};
